import Helloworld from "./1_Helloworld";

const element = <Helloworld />

function ComponentAsElement() {
  return <></>
}

export default ComponentAsElement